import gql from 'graphql-tag'

/* Query para obtener todos los eventos disponibles y ponerlos en la página principal y en la sección de eventos */
const FETCH_EVENTS = gql `
query Events {
  events {
    id
    name
    estatus
    category
    subcategory
    eventType
	  registrationWebSite
    tags
    startDate
    modality
    eventImage
    eventFlyer
    private
    freeEvent
    address {
        city
    }
    organizer {
      companyName
    }
  }
}`

/* Query para obtener los eventos disponibles de un organizador.
  Esta Query se usa cuando un usuario cualquiera ingresa a una url que le compartió algún organizador */
const FETCH_ORGANIZER_EVENTS = gql `
query OrganizerEvents ($id: String!){
  organizerEvents(id: $id) {
    id
    name
    estatus
    category
    subcategory
    eventType
	  registrationWebSite
    tags
    startDate
    modality
    eventImage
    eventFlyer
    private
    freeEvent
    address {
      city
    }
    organizer {
      companyName
      profilePicture
      imgBackground
    }
  }
}`

/* Query para obtener la información de todos los eventos en el tablero del usuario de tipo organización */
const FETCH_USER_EVENTS = gql `
query MyEvents {
  myEvents {
    id
    name
    estatus
    category
    subcategory
    eventType
    registrationWebSite
    startDate
    modality
    eventImage
    eventFlyer
    darkMode
    address {
    city
    }
    organizer {
    companyName
    }
    orders {
      id
      orderStatus
      paymentInformation {
        name
        lastName
        paymentType
      }
    attendeeInformation {
        id
        name
        lastName
        ticketName
        email
        companyName
        checkedIn
        extraFields
    }
    updatedAt
    createdAt
    total
    }
    quantityOfCourtesies
    courtesy
  }
}`

/* Query que obtiene los datos de un evento ya sea para editarlo o para mostrarlos en el detalle del evento */
const FETCH_EVENT_DETAILS = gql `
  query EventDetails ($id: String!) {
    eventById(id: $id) {
      id
      name
      details
      modality
      amenities
      category
      subcategory
      eventType
      registrationWebSite
      sponsors
      eventImage
      eventFlyer
      private
      tags
      freeEvent
      totalBreakdown
      darkMode
      installments
      onlineEventUrl
      meetingId
      meetingPass
      estatus
      productsPerOrder
      tickets {
          id
          externalId
          name
          accessType
          price
          estatus
          inventory {
              inventoryType
              inventoryEstatus
              quantity
              sold
          }
      }
      haveCoupons
      hideCompany
	    hidePhone
      offerBilling
      quantityOfCourtesies
      courtesy
      coupons {
          id
          name
          percentOff
      }
      extraFields {
        name
        formattedName
        fieldType
        description
        required
        options
      }
      organizer {
          companyName
          profilePicture
      }
      startDate
      endDate
      startTime
      endTime
      address {
          name
          lat
          lng
          formattedAddress
          city
          state
      }
      faqs {
          question
          answer
      }
      socialMedia {
          facebook
          twitter
          linkedin
          instagram
          youtube
      }
      contactDetails {
          email
          tel
          webSite
      }
      hasSurvey
      editorEmail
      surveyEndDate
      publishedURL
      editorURL
      spreadsheetId
      message
    }
  }
`


export { FETCH_EVENTS, FETCH_ORGANIZER_EVENTS, FETCH_EVENT_DETAILS, FETCH_USER_EVENTS }